import React, { StrictMode, Fragment } from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from 'components/scrollTop';
import { ToastContainer } from 'react-toastify';
import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import "react-toastify/dist/ReactToastify.css";
import './index.scss';

const APP_TITLE: string | undefined = process.env.REACT_APP_TITLE;
const BUGSNAG_ID: string | undefined = process.env.REACT_APP_BUGSNAG_ID;
const BUGSNAG_ENV: string | undefined = process.env.REACT_APP_BUGSNAG_ENV;
const bugsnagEnabled: boolean = BUGSNAG_ID !== undefined && BUGSNAG_ENV !== undefined;

if (bugsnagEnabled) {
  Bugsnag.start({
    apiKey: BUGSNAG_ID!,
    releaseStage: BUGSNAG_ENV,
    appVersion: process.env.REACT_APP_VERSION,
    plugins: [new BugsnagPluginReact()],
  })
}

const ErrorBoundary = bugsnagEnabled ? 
  Bugsnag.getPlugin('react')!.createErrorBoundary(React) : 
  Fragment;

ReactDOM.render(
  <StrictMode>
    <Helmet>
      <title>{APP_TITLE}</title>
    </Helmet>
    <BrowserRouter>
      <ScrollTop>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ScrollTop>
    </BrowserRouter>
    <ToastContainer
      autoClose={7000}
      className="toast-alert"
      position="top-center"
      hideProgressBar={true}
    />
  </StrictMode>,
  document.getElementById('root')
);